import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import PlaceIcon from '@mui/icons-material/Place';
import PublisherCard from '../../components/publisherCard';
import usePublisher from '../../../store/models/publisher/usePublisher';
import * as styles from './styles';

function NearMe({ onSync, onShare }) {
    const { nearMePublishers } = usePublisher();

    function renderSectionHeader() {
        return (
            <Box sx={styles.sectionHeader}>
                <Box>
                    <Box sx={styles.eyebrow}>
                        <PlaceIcon sx={styles.pinIcon} />
                        Near you
                    </Box>
                    <Typography variant="h2" sx={styles.title}>
                        What's happening in{' '}
                        <Box component="span" sx={styles.gradientText}>your area</Box>
                    </Typography>
                    <Typography sx={styles.subtitle}>
                        Geo-localised picks distinct from your recommendations.
                    </Typography>
                </Box>
            </Box>
        );
    }

    function renderGrid() {
        return (
            <Box sx={styles.grid}>
                {nearMePublishers.map((publisher) => (
                    <PublisherCard
                        key={publisher.id}
                        publisher={publisher}
                        onSync={onSync}
                        onShare={onShare}
                    />
                ))}
            </Box>
        );
    }

    if (!nearMePublishers.length) return null;

    return (
        <Box component="section" sx={styles.section}>
            <Container maxWidth="xl">
                {renderSectionHeader()}
                {renderGrid()}
            </Container>
        </Box>
    );
}

export default NearMe;
